(function () {

  angular
    .module("alk.marketing")
    .directive("marketingFooter", marketingFooter);

  //marketingFooter.inject = [];
  function marketingFooter() {
    var directive = {
      template: require("./footer.html"),
      link: link,
      restrict: "E",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {
     scope.year=new Date().getFullYear();}
  }

})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-marketing/footer.directive.js